import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createPaginationSchema } from '../../common/utils/schema';
import { Page, PageRequestParams } from '../../common/queryClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { RecordWithKeys } from '../../common/types';
import { ProcessingEventDirectoryEntrySchema } from '../schema/ProcessingEventDirectoryEntrySchema';
import { ProcessingEventDirectoryEntryType } from '../schema/types';
import { ProcessingEventUrl } from './ProcessingEventUrl';

export const processingEventsFilterKeys = [
  ...ProcessingEventDirectoryEntrySchema.keyof().exclude([
    'id',
    'dataObjectCodeName',
    'hasAccess',
    'processingMethodId',
    'dataProcessingScopeId',
    'calculationStartTime',
    'calculationEndTime',
    'validationStartTime',
    'validationEndTime',
    'outputCalculationErrors',
    'outputVersionMissingSourceData',
    'outputVersionValidationErrorLevelId',
    'outputVersionStatus',
    'outputVersion',
    'outputVersionId',
  ]).options,
  'userFollowedDataObjectGroups' as const,
  'valueDays' as const,
  'onlyLastValueDate' as const,
  'dataManager' as const,
  'outputCode' as const,
  'sourceCode' as const,
];

export type ProcessingEventsFilterKey =
  (typeof processingEventsFilterKeys)[number];

export const processingEventsSortKeys = [
  ...ProcessingEventDirectoryEntrySchema.keyof().exclude([
    'id',
    'hasAccess',
    'createdBy',
  ]).options,
  'creatorUsername',
  'creatorFirstName',
  'creatorLastName',
] as const;

export type ProcessingEventsSortKey = (typeof processingEventsSortKeys)[number];

export type ProcessingEventsFilter = RecordWithKeys<
  ProcessingEventsFilterKey,
  string | undefined,
  {
    errorLevelId: number[];
    processingTypeId: number[];
    statusId: number[];
    userFollowedDataObjectGroups?: boolean;
    onlyLastValueDate?: boolean;
    valueDate?: [string, string];
    startTime?: [string, string];
    endTime?: [string, string];
    outputDataObjectGroupType: string[];
    refetch?: boolean;
    sourceCode?: string;
    outputCode?: string;
  }
>;

export const ProcessingEventDirectoryPageSchema = createPaginationSchema(
  ProcessingEventDirectoryEntrySchema,
);

const getInputProcessingEvents = (
  params: Partial<ProcessingEventsFilter> & PageRequestParams,
) =>
  apiClient
    .get<
      Page<ProcessingEventDirectoryEntryType>
    >(expand(ProcessingEventUrl.INPUT_PROCESSING_EVENTS, params))
    .then((response) =>
      ProcessingEventDirectoryPageSchema.parse(response.data),
    );

export const useInputProcessingEventsQuery = createApiQueryHook(
  ['inputProcessingEvents'],
  getInputProcessingEvents,
);
